function sendPause(client: any, guild: any) { 
  client.send(JSON.stringify({
    message: "pause",
    guild: guild?.id
  })) 
}

function sendResume(client: any, guild: any) { 
  client.send(JSON.stringify({
    message: "resume",
    guild: guild?.id
  })) 
}

function sendSkip(client: any, guild: any) { 
  client.send(JSON.stringify({
    message: "skip",
    guild: guild?.id
  })) 
}

function sendPrevious(client: any, guild: any) {
  client.send(JSON.stringify({
    message: "previous",
    guild: guild?.id
  })) 
}

function sendLoop(client: any, guild: any, status: string) {
  client.send(JSON.stringify({
    message: "loop",
    guild: guild?.id,
    status: status ? status : "none"
  })) 
}

function sendShuffle(client: any, guild: any) {
  client.send(JSON.stringify({
    message: "shuffle",
    guild: guild?.id
  })) 
}

export { sendLoop, sendPause, sendPrevious, sendResume, sendShuffle, sendSkip }